import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SwiperSlide, Swiper } from 'swiper/react';
import "swiper/css";
import AreaCard from '../area-card/AreaCard';
import "../category-list/categoryList.scss";

const AreaList = () => {
    const [areas, setAreas] = useState([]);
    useEffect(() => {
        const getAreas = async () => {
            const response = await axios.get('https://www.themealdb.com/api/json/v1/1/list.php?a=list');
            setAreas(response.data.meals.slice(0, 9));
        }
        getAreas();
    }, []);
    return (
        <div className="category-list">
            <Swiper
                grabCursor={true}
                spaceBetween={10}
                slidesPerView={'auto'}

            >
                {
                    areas.map((item, index) => (
                        <SwiperSlide key={index}>
                            {/* <p>{item.strArea}</p> */}
                            <AreaCard area={item.strArea} />
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    )
}

export default AreaList